import { on } from 'helpers/dom'
import { useEffect, useState, useRef } from 'preact/hooks'
import Icon from '../icon/icon'
import LoaderSpin from '../loader-spin/loader-spin'

function QuantityInput({ min = 0, max = 9999, quantity, setQuantity, iconClass = 'text-grey-500', disabled = false, classWrap, classButton = 'w-11 h-10 p-0', isLoading = false, inputKey }) {
  const [message, setMessage] = useState(null)
  const inputRef = useRef(null)

  const onChange = (count) => {
    const current = quantity + count
    if (current >= min && current <= max) {
      setQuantity(current)
    }
  }

  const onValidate = (value) => {
    return /^\d+$/.test(value)
  }

  const onChangeInput = (e) => {
    e.preventDefault()
    const currentQuantity = parseInt(e.target.value)
    const isValidated = onValidate(currentQuantity)

    if (isNaN(currentQuantity)) {
      inputRef.current.value = quantity
      return
    }

    if (inputRef && inputRef.current) {
      inputRef.current.value = currentQuantity
    }

    if (!isValidated) {
      if (currentQuantity !== 0 && currentQuantity < min) {
        setMessage('Enter a positive number')
      } else {
        setMessage('Enter only numbers')
      }
      return
    }

    if (currentQuantity <= max && currentQuantity >= 0) {
      setMessage(null)
      setQuantity(currentQuantity)
    } else {
      changeMessage()
    }
  }

  const changeMessage = () => {
    if (max > 1) {
      setMessage(`We have ${max} items`)
    } else {
      setMessage('We have only 1 item')
    }
  }

  useEffect(() => {
    if (inputRef && inputRef.current) {
      on(
        'keydown',
        (event) => {
          if (event.key === 'Enter') {
            event.preventDefault()
            onChangeInput(event)
          }
        },
        inputRef.current
      )
    }
  }, [])

  return (
    <>
      <div className={`relative flex h-10 items-center justify-between overflow-hidden border border-default ${classWrap} ${classWrap.includes('rounded') ? '' : 'rounded-sm'}`}>
        <button
          type="button"
          name="minus"
          className={`flex items-center justify-center text-grey-500 group hover:bg-grey-100 ${classButton} ${
            quantity <= min || disabled || isLoading ? 'pointer-events-none cursor-not-allowed opacity-50' : ''
          }`}
          disabled={quantity < min || disabled || isLoading}
          onClick={() => onChange(-1)}
          title="Decrease Quantity"
          aria-label="Decrease Quantity"
        >
          <Icon viewBox="0 0 16 16" name="icon-minus"
            className={`w-4 h-4 group-hover:text-grey-700 ${iconClass}`} />
        </button>
        <div className="relative w-[26px]">
          {!isLoading ? (
            <input
              type="number"
              ref={inputRef}
              value={quantity}
              className="w-[26px] border-none p-0 text-center text-sm text-grey-700 !shadow-none !ring-0"
              min={min}
              max={max}
              onChange={onChangeInput}
              onBlur={onChangeInput}
              readOnly={disabled}
              aria-label="page-number"
              key={inputKey}
            />
          ) : (
            <LoaderSpin width="4" height="4" />
          )}
        </div>
        <button
          type="button"
          name="plus"
          className={`flex items-center justify-center text-grey-500 group hover:bg-grey-100 ${classButton} ${
            quantity < min || quantity >= max || disabled || isLoading ? 'pointer-events-none cursor-not-allowed opacity-50' : ''
          }`}
          disabled={quantity < min || quantity === max || disabled || isLoading}
          onClick={() => onChange(1)}
          title="Increase Quantity"
          aria-label="Increase Quantity"
        >
          <Icon viewBox="0 0 16 16" name="icon-plus"
            className={`w-4 h-4 group-hover:text-grey-700 ${iconClass}`} />
        </button>
      </div>
      {message && <span className="text-xs text-error-content">{message}</span>}
    </>
  )
}

export default QuantityInput
